var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs tabs-v3 is-small general-configuration-tabs entity-tabs"},[_c('ul',_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab.key,class:{ 'active-customer': _vm.activeKey === tab.key }},[_c('a',{staticClass:"tab",on:{"click":function($event){return _vm.$emit('change', tab)}}},[_vm._v(_vm._s(tab.label))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }